export default __webpack_public_path__ + "static/media/0078.069c0e0d.png";